import { Link } from "react-router-dom";
import type { FilmTitle } from "@/types/film";
import Badge, { tagTone } from "@/components/base/Badge";

interface TitleCardProps {
  item: FilmTitle;
  showSynopsis?: boolean;
}

export default function TitleCard({ item, showSynopsis = true }: TitleCardProps) {
  const primaryTag = item.tags[0];

  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block rounded-lg bg-background-900 border border-background-800 overflow-hidden transition-colors duration-300 hover:border-primary-500"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-800">
        <img
          src={item.cover}
          alt={`${item.title} ${item.originalTitle} 海报`}
          title={`${item.title} - 欧美影视推荐`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-background-950/10 to-transparent" />

        <div className="absolute left-2 top-2 flex flex-wrap gap-1 max-w-[80%]">
          {primaryTag ? <Badge label={primaryTag} tone={tagTone(primaryTag)} /> : null}
        </div>

        <div className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-background-950/80 px-1.5 py-0.5">
          <i className="ri-star-fill text-accent-500 text-xs" />
          <span className="font-label text-xs text-foreground-100">{item.rating.toFixed(1)}</span>
        </div>

        {showSynopsis ? (
          <div className="absolute inset-x-0 bottom-0 translate-y-2 p-3 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
            <p className="text-[12px] leading-relaxed text-foreground-200 line-clamp-3">
              {item.synopsis}
            </p>
          </div>
        ) : null}
      </div>

      <div className="px-3 py-2.5">
        <h3 className="text-sm font-medium text-foreground-100 truncate group-hover:text-accent-400 transition-colors">
          {item.title}
        </h3>
        <p className="mt-1 text-[12px] text-foreground-400 truncate">
          {item.year} · {item.genres.slice(0, 2).join(" / ")} · {item.region}
        </p>
      </div>
    </Link>
  );
}